import React from 'react';
import './style.scss';

function NoData() {
     return <div className="no-data">No Data</div>;
}

export default NoData;
